import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/uk/501/',
    component: ComponentCreator('/uk/501/', 'ccd'),
    exact: true
  },
  {
    path: '/uk/articles/',
    component: ComponentCreator('/uk/articles/', '1de'),
    exact: true
  },
  {
    path: '/uk/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/uk/articles/2024/07/09/diskusija-lj-nj-cyrl/', 'b76'),
    exact: true
  },
  {
    path: '/uk/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/uk/articles/2024/07/09/diskusija-lj-nj/', 'b9a'),
    exact: true
  },
  {
    path: '/uk/articles/archive/',
    component: ComponentCreator('/uk/articles/archive/', 'ab4'),
    exact: true
  },
  {
    path: '/uk/articles/authors/',
    component: ComponentCreator('/uk/articles/authors/', '429'),
    exact: true
  },
  {
    path: '/uk/search/',
    component: ComponentCreator('/uk/search/', '06b'),
    exact: true
  },
  {
    path: '/uk/',
    component: ComponentCreator('/uk/', '11e'),
    exact: true
  },
  {
    path: '/uk/',
    component: ComponentCreator('/uk/', '44d'),
    routes: [
      {
        path: '/uk/',
        component: ComponentCreator('/uk/', '4dd'),
        routes: [
          {
            path: '/uk/tags/',
            component: ComponentCreator('/uk/tags/', '389'),
            exact: true
          },
          {
            path: '/uk/tags/comparative/',
            component: ComponentCreator('/uk/tags/comparative/', 'ec9'),
            exact: true
          },
          {
            path: '/uk/tags/grammar/',
            component: ComponentCreator('/uk/tags/grammar/', '28f'),
            exact: true
          },
          {
            path: '/uk/tags/interslavic/',
            component: ComponentCreator('/uk/tags/interslavic/', 'e15'),
            exact: true
          },
          {
            path: '/uk/tags/language-learning/',
            component: ComponentCreator('/uk/tags/language-learning/', '3fc'),
            exact: true
          },
          {
            path: '/uk/tags/linguistics/',
            component: ComponentCreator('/uk/tags/linguistics/', 'ed1'),
            exact: true
          },
          {
            path: '/uk/tags/personal-pronouns/',
            component: ComponentCreator('/uk/tags/personal-pronouns/', '999'),
            exact: true
          },
          {
            path: '/uk/tags/pronouns/',
            component: ComponentCreator('/uk/tags/pronouns/', '379'),
            exact: true
          },
          {
            path: '/uk/tags/slavic-languages/',
            component: ComponentCreator('/uk/tags/slavic-languages/', '931'),
            exact: true
          },
          {
            path: '/uk/tags/вивчення-мови/',
            component: ComponentCreator('/uk/tags/вивчення-мови/', '1cd'),
            exact: true
          },
          {
            path: '/uk/tags/граматика/',
            component: ComponentCreator('/uk/tags/граматика/', '4e5'),
            exact: true
          },
          {
            path: '/uk/tags/займенники/',
            component: ComponentCreator('/uk/tags/займенники/', '2dc'),
            exact: true
          },
          {
            path: '/uk/tags/міжсловянська-мова/',
            component: ComponentCreator('/uk/tags/міжсловянська-мова/', 'c70'),
            exact: true
          },
          {
            path: '/uk/tags/міжсловянська/',
            component: ComponentCreator('/uk/tags/міжсловянська/', '3df'),
            exact: true
          },
          {
            path: '/uk/tags/порівняння-мов/',
            component: ComponentCreator('/uk/tags/порівняння-мов/', '3c5'),
            exact: true
          },
          {
            path: '/uk/',
            component: ComponentCreator('/uk/', 'b87'),
            routes: [
              {
                path: '/uk/learn/faq/',
                component: ComponentCreator('/uk/learn/faq/', '816'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/',
                component: ComponentCreator('/uk/learn/grammar/', 'db8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/adjectives/',
                component: ComponentCreator('/uk/learn/grammar/adjectives/', 'cf1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/conjunctions/',
                component: ComponentCreator('/uk/learn/grammar/conjunctions/', 'cea'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/nouns/',
                component: ComponentCreator('/uk/learn/grammar/nouns/', '1ab'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/numerals/',
                component: ComponentCreator('/uk/learn/grammar/numerals/', '366'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/prepositions/',
                component: ComponentCreator('/uk/learn/grammar/prepositions/', '229'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/pronouns/',
                component: ComponentCreator('/uk/learn/grammar/pronouns/', '23e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/syntax/',
                component: ComponentCreator('/uk/learn/grammar/syntax/', 'd68'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/grammar/verbs/',
                component: ComponentCreator('/uk/learn/grammar/verbs/', 'e4f'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/introduction/',
                component: ComponentCreator('/uk/learn/introduction/', 'f88'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/uk/learn/misc/constructed-slavic-languages/', '32a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/design-criteria/',
                component: ComponentCreator('/uk/learn/misc/design-criteria/', '100'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/history/',
                component: ComponentCreator('/uk/learn/misc/history/', '020'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/language-comparison/',
                component: ComponentCreator('/uk/learn/misc/language-comparison/', '6a9'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/numbers-1-10/',
                component: ComponentCreator('/uk/learn/misc/numbers-1-10/', 'c6f'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/uk/learn/misc/pan-slavic-relay/', 'a49'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/misc/personal-pronouns/',
                component: ComponentCreator('/uk/learn/misc/personal-pronouns/', '4d7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/orthography/',
                component: ComponentCreator('/uk/learn/orthography/', 'd54'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/phonology/',
                component: ComponentCreator('/uk/learn/phonology/', 'f1e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/pronunciation/',
                component: ComponentCreator('/uk/learn/pronunciation/', '7b6'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/simple-grammar/',
                component: ComponentCreator('/uk/learn/simple-grammar/', '207'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/simple-grammar/level-1/',
                component: ComponentCreator('/uk/learn/simple-grammar/level-1/', '216'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/simple-grammar/level-2/',
                component: ComponentCreator('/uk/learn/simple-grammar/level-2/', '1d9'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/vocabulary/derivation/',
                component: ComponentCreator('/uk/learn/vocabulary/derivation/', '1bc'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/uk/learn/vocabulary/flavourisation/', '142'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/learn/vocabulary/word-formation/',
                component: ComponentCreator('/uk/learn/vocabulary/word-formation/', '4bb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/uk/resources/',
                component: ComponentCreator('/uk/resources/', '115'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/uk/resources/applets/',
                component: ComponentCreator('/uk/resources/applets/', '548'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/uk/resources/applets/intelligibility/',
                component: ComponentCreator('/uk/resources/applets/intelligibility/', '4ba'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/uk/resources/applets/transliterator/',
                component: ComponentCreator('/uk/resources/applets/transliterator/', 'cda'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/uk/resources/keyboards/',
                component: ComponentCreator('/uk/resources/keyboards/', '548'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
